import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=6625d5d2&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./newsList.vue?vue&type=style&index=0&id=6625d5d2&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6625d5d2",
  "3046f6a8"
  
)

export default component.exports